/**
 * Service layer — Owner's Project Criteria (OPC) report. Calls api/opc-report.js (native pdf-lib)
 * with a Clerk token. `working:true` = draft preview; `working:false` = issued copy. Mirrors
 * services/predesign.js.
 */

async function render(projectId, working) {
  const headers = { 'Content-Type': 'application/json' }
  try { if (window.__clerkGetToken) { const t = await window.__clerkGetToken(); if (t) headers['Authorization'] = 'Bearer ' + t } }
  catch (_) { /* server rejects unauthenticated */ }
  const res = await fetch('/api/opc-report', { method: 'POST', headers, body: JSON.stringify({ projectId, working }) })
  if (!res.ok) { const j = await res.json().catch(() => ({})); return { error: j.error || ('Report failed (' + res.status + ')') } }
  const blob = await res.blob()
  return { pdfUrl: URL.createObjectURL(blob) }
}

/** Working-draft preview (stamped "WORKING DRAFT - NOT ISSUED"). */
export function previewOpcReport(projectId) { return render(projectId, true) }

/** Issued copy (no draft stamp). */
export function generateOpcReport(projectId) { return render(projectId, false) }

/**
 * Freeze the issued OPC as a milestone's final document (server renders + stores a milestone_documents
 * row, source 'opc-report'). Called when the Pre-design Research milestone is posted. → { ok, url } | { error }.
 */
export async function freezeOpcReport(projectId, milestoneId) {
  const headers = { 'Content-Type': 'application/json' }
  try { if (window.__clerkGetToken) { const t = await window.__clerkGetToken(); if (t) headers['Authorization'] = 'Bearer ' + t } }
  catch (_) { /* server rejects unauthenticated */ }
  try {
    const res = await fetch('/api/opc-report', { method: 'POST', headers, body: JSON.stringify({ projectId, milestoneId, freeze: true }) })
    return res.json().catch(() => ({ error: 'Bad response from the report service.' }))
  } catch (e) { return { error: (e && e.message) || 'Freeze request failed.' } }
}
